module.exports = __webpack_public_path__ + "img/65.ec240be0.gif";